<div class="ibox detailed-view-ibox"
     *ngIf="settingsKeyLogService.showDetailedView && settingsKeyLogService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">{{settingsKeyLogService.chosenCorporation.name}}</div>
        <span class="close-detailed-view" (click)="settingsKeyLogService.toggleDetailedView(null, false)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm" submittable autocomplete="off">
                <div>
                    <div class="detailed-view-navigation">
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                            <div class="button-section"
                                 (click)="changeNavPosition('tab_settings')"
                                 [ngStyle]="{'background-color': navPosition == 'tab_settings' ? '#ebebeb' : ''}">
                                Tab Settings
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6 col-xs-6 no-padding">
                            <div class="button-section"
                                 (click)="changeNavPosition('notifications')"
                                 [ngStyle]="{'background-color': navPosition == 'notifications' ? '#ebebeb' : ''}">
                                Notifications
                            </div>
                        </div>
                    </div>
                </div>
                <div class="services-list" *ngIf="navPosition == 'tab_settings'">
                    <div class="services-list-item m-t-md">
                        <mat-slide-toggle name="uniqueTags"
                                          (change)="onSubmit({uniqueTags: form.value.uniqueTags})"
                                          [ngModel]="settingsKeyLogService.selectedItemData.uniqueTags">
                        </mat-slide-toggle>
                        <span>Unique Key Tags</span>
                    </div>

                    <div class="services-list-item m-t-md">
                        <mat-slide-toggle name="mandatoryUnitToKey"
                                          (change)="onSubmit({mandatoryUnitToKey: form.value.mandatoryUnitToKey})"
                                          [ngModel]="settingsKeyLogService.selectedItemData.mandatoryUnitToKey">
                        </mat-slide-toggle>
                        <span>Key Must Be Assigned To A Unit/Room</span>
                    </div>

                    <div class="services-list-item m-t-md">
                        <mat-slide-toggle name="useSignaturePadStatus"
                                          (change)="onSubmit({useSignaturePadStatus: form.value.useSignaturePadStatus})"
                                          [ngModel]="settingsKeyLogService.selectedItemData.useSignaturePadStatus">
                        </mat-slide-toggle>
                        <span>Use Signature Pad</span>
                    </div>
                </div>
                <div *ngIf="navPosition == 'notifications'">
                    <div class="settings-amenities-slider-container m-t-sm">
                        <span>Notify Staff</span>
                    </div>
                    <div class="m-b-xs filter-checkbox">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   [(ngModel)]="settingsKeyLogService.keyCreatedStaffCheckbox"
                                   [disabled]="!emailTemplateIsSet('created')"
                                   name="keyCreatedStaffCheckbox"
                                   id="keyCreatedStaffCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="keyCreatedStaffCheckbox"
                                   [title]="!emailTemplateIsSet('created') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text" (click)="showNotificationModal('created')">
                            Key Created
                        </span>
                    </div>
                    <div class="m-b-xs" *ngIf="settingsKeyLogService.keyCreatedStaffCheckbox">
                        <multiselect-field name="createdStaffMultiselect"
                                           [data]="settingsKeyLogService.userRoles"
                                           [(ngModel)]="settingsKeyLogService.createdStaffMultiselectArray"
                                           (update)="submitNotificationsField()">
                        </multiselect-field>
                    </div>

                    <div class="m-b-xs filter-checkbox">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   [(ngModel)]="settingsKeyLogService.keyDeletedStaffCheckbox"
                                   [disabled]="!emailTemplateIsSet('deleted')"
                                   name="keyDeletedStaffCheckbox"
                                   id="keyDeletedStaffCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="keyDeletedStaffCheckbox"
                                   [title]="!emailTemplateIsSet('deleted') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text" (click)="showNotificationModal('deleted')">
                            Key Deleted
                        </span>
                    </div>
                    <div class="m-b-xs" *ngIf="settingsKeyLogService.keyDeletedStaffCheckbox">
                        <multiselect-field name="deletedStaffMultiselect"
                                           [data]="settingsKeyLogService.userRoles"
                                           [(ngModel)]="settingsKeyLogService.deletedStaffMultiselectArray"
                                           (update)="submitNotificationsField()">
                        </multiselect-field>
                    </div>

                    <div class="m-b-xs filter-checkbox">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   [(ngModel)]="settingsKeyLogService.keyModifiedStaffCheckbox"
                                   [disabled]="!emailTemplateIsSet('modified')"
                                   name="keyModifiedStaffCheckbox"
                                   id="keyModifiedStaffCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="keyModifiedStaffCheckbox"
                                   [title]="!emailTemplateIsSet('modified') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text" (click)="showNotificationModal('modified')">
                            Key Modified
                        </span>
                    </div>
                    <div class="m-b-xs" *ngIf="settingsKeyLogService.keyModifiedStaffCheckbox">
                        <multiselect-field name="modifiedStaffMultiselect"
                                           [data]="settingsKeyLogService.userRoles"
                                           [(ngModel)]="settingsKeyLogService.modifiedStaffMultiselectArray"
                                           (update)="submitNotificationsField()">
                        </multiselect-field>
                    </div>

                    <div class="m-b-xs filter-checkbox">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   [(ngModel)]="settingsKeyLogService.keySignedOutStaffCheckbox"
                                   [disabled]="!emailTemplateIsSet('signed_out')"
                                   name="keySignedOutStaffCheckbox"
                                   id="keySignedOutStaffCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="keySignedOutStaffCheckbox"
                                   [title]="!emailTemplateIsSet('signed_out') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text" (click)="showNotificationModal('signed_out')">
                            Key Signed Out
                        </span>
                    </div>
                    <div class="m-b-xs" *ngIf="settingsKeyLogService.keySignedOutStaffCheckbox">
                        <multiselect-field name="signedOutStaffMultiselect"
                                           [data]="settingsKeyLogService.userRoles"
                                           [(ngModel)]="settingsKeyLogService.signedOutStaffMultiselectArray"
                                           (update)="submitNotificationsField()">
                        </multiselect-field>
                    </div>

                    <div class="m-b-xs filter-checkbox">
                        <label class="img-checkbox">
                            <input type="checkbox"
                                   [(ngModel)]="settingsKeyLogService.keyReturnedStaffCheckbox"
                                   [disabled]="!emailTemplateIsSet('returned')"
                                   name="keyReturnedStaffCheckbox"
                                   id="keyReturnedStaffCheckbox"
                                   (change)="submitNotificationsField()">
                            <label for="keyReturnedStaffCheckbox"
                                   [title]="!emailTemplateIsSet('returned') ? 'Please select email template first' : ''">
                                <svg-checked></svg-checked>
                            </label>
                        </label>
                        <span class="mtv-primary-color clickable-text" (click)="showNotificationModal('returned')">
                            Key Returned
                        </span>
                    </div>
                    <div class="m-b-xs" *ngIf="settingsKeyLogService.keyReturnedStaffCheckbox">
                        <multiselect-field name="returnedStaffMultiselect"
                                           [data]="settingsKeyLogService.userRoles"
                                           [(ngModel)]="settingsKeyLogService.returnedStaffMultiselectArray"
                                           (update)="submitNotificationsField()">
                        </multiselect-field>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-key-log/settings-key-log-detailed-view/settings-key-log-detailed-view.component.html